import Modal from 'components/shared/Modal'
import { useIntl } from 'react-intl'
import { ZonesModalBody, ZonesModalWrapper } from './styles'
import ZonesCategoryJamango from './components/ZonesCategoryJamango'
import ZonesCategoryRelax from './components/ZonesCategoryRelax'
import ZonesCategorySaunaria from './components/ZonesCategorySaunaria'
import { useResolutions } from 'store/resolutions'
import ZonesModalBackButton from './components/ZonesModalBackButton'

interface ZonesModalProps {
    isOpened: boolean
    closeModal: () => void
}

const ZonesModal = ({ isOpened, closeModal }: ZonesModalProps) => {
    const { formatMessage } = useIntl()
    const { isMobile } = useResolutions()

    return (
        <ZonesModalWrapper>
            <Modal
                isOpened={isOpened}
                maxWidth={770}
                onClose={closeModal}
                isMobileFullscreen
                hasGlobalHeader
                headerMessage={formatMessage({
                    id: 'tickets.zones_modal_header',
                    defaultMessage: 'Strefy Suntago',
                })}
                testIdPrefix="zones-modal"
            >
                <ZonesModalBody gap={8}>
                    <ZonesCategoryJamango />
                    <ZonesCategoryRelax />
                    <ZonesCategorySaunaria />
                    {isMobile && <ZonesModalBackButton onClick={closeModal} />}
                </ZonesModalBody>
            </Modal>
        </ZonesModalWrapper>
    )
}

export default ZonesModal
